import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/bike"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4H9.53039L6.2394 7.05592L5.44868 4.68377C5.31257 4.27543 4.93043 4 4.5 4H2V6H3.77924L4.11854 7.01788C3.99729 7.00605 3.87435 7 3.75 7C1.67893 7 0 8.67893 0 10.75C0 12.8211 1.67893 14.5 3.75 14.5C5.56422 14.5 7.07753 13.2117 7.42499 11.5H8.57501C8.92247 13.2117 10.4358 14.5 12.25 14.5C14.3211 14.5 16 12.8211 16 10.75C16 8.77428 14.4721 7.15541 12.5334 7.01055L11.6595 3.51493C11.4369 2.62459 10.637 2 9.71922 2H8V4ZM7.07323 9.01093C7.15546 9.16774 7.22692 9.33109 7.28662 9.5H8.71338C9.03756 8.58281 9.70843 7.8294 10.5685 7.3972L10.2374 6.07276L7.07323 9.01093ZM3.75 9C3.8722 9 3.99148 9.01253 4.10661 9.03636L3.31955 9.76721C3.01822 10.047 2.91889 10.4828 3.0692 10.8655C3.2195 11.2483 3.58879 11.5 4 11.5H5.33159C5.05073 12.0912 4.4481 12.5 3.75 12.5C2.7835 12.5 2 11.7165 2 10.75C2 9.7835 2.7835 9 3.75 9ZM11.0811 9.44759C10.7244 9.76796 10.5 10.2328 10.5 10.75C10.5 11.7165 11.2835 12.5 12.25 12.5C13.2165 12.5 14 11.7165 14 10.75C14 10.0853 13.6294 9.50709 13.0835 9.21086L13.4701 10.7575L11.5299 11.2425L11.0811 9.44759Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Bike16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Bike16 = createIcon(IconComponent);